/* eslint-disable prettier/prettier */
import request from '@/utils/request'

// 获取供应商认定申请基本信息
export function supplierApplyBase(applyCode) {
    return request({
        url: `/api/srm-slcm/suppIdentifyApply/getSuppAppByIdForAPP/${applyCode}`,
        method: 'get'
    })
}

// 获取供应商认定申请供应商信息
export function supplierApplyInfo(applyCode) {
    return request({
        url: `/api/srm-slcm/suppIdentifyApply/getSuppAppDetailByIdForAPP/${applyCode}`,
        method: 'get'
    })
}

export function saveDevUser(obj) {
    return request({
        url: '/api/srm-slcm/suppIdentifyApply/saveDevUser',
        method: 'post',
        data: obj
    })
}